// extracted by mini-css-extract-plugin
module.exports = {"reportHistoryAvatar":"ReportHistoryAvatar_reportHistoryAvatar__AlJxb","title":"ReportHistoryAvatar_title__6Y4gx","text":"ReportHistoryAvatar_text__3CzzB"};